import { useTranslation } from "react-i18next";

export default function StatusBadge({ status }) {
  const { t } = useTranslation();
  return (
    <span className={`qw-badge ${status}`}>
      <span className="dot"></span>
      {t(`quotations.st.${status}`)}
    </span>
  );
}
